import React, { useEffect, useState } from 'react';
import cookieStore from 'js-cookie';
import { models } from 'powerbi-client';
import { useHistory } from 'react-router-dom';
import { ReactComponent as LeftArrow } from './../../assets/img/left-arrow.svg';
import { PowerBIEmbed } from 'powerbi-client-react';
import './powerBi.css';
import { Button, Col, DatePicker, Form, Row, Tooltip, message } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import moment from 'moment';
import { logout, setDashboardFilter, setPbiDashboardData } from '../../store/actions/dashboardAction';

const DASHBOARD_PDF_DOWNLOAD = 'Dashboard/PowerBiDownload';

export default function PowerBiDashboard(props: any) {
  const { dashboardType, table, column, filterColumnName, timePeriodFilterRequired, filterTableName, hideFooterTabs } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [reloadPbi, setReloadPbi] = useState(0);
  const [searchForm] = Form.useForm();
  const [config, setConfig] = useState<any>();
  const [messageApi, contextHolder] = message.useMessage();
  const [isVisible, setIsVisible] = useState(true);
  const { dashboardFilter, isFilterApplied } = useSelector((state: RootState): any => state?.dashboard || {});

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('data') || '{}');
    const accessToken = cookieStore.get('accessToken') || '';
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', AccessToken: accessToken },
      body: JSON.stringify({ dashboardType }),
    };
    fetch(`${process.env.REACT_APP_API_BASE_URL}Provider/Search/Powerbidashboard`, requestOptions)
      .then((response) => response.json())
      .then((detail) => {
        if (detail?.isSuccess) {
          dispatch(setPbiDashboardData(detail));
          const { TokenType: { Embed }, Permissions: { All }, ViewMode: { View },
          } = models;
          setConfig({
            type: 'report',
            tokenType: Embed,
            accessToken: detail.embedToken.token,
            embedUrl: detail.embedUrl,
            id: detail.id,
            permissions: All,
            viewMode: View,
            settings: {
              filterPaneEnabled: false,
              navContentPaneEnabled: !hideFooterTabs,
              localeSettings: {
                formatLocale: '',
                language: '',
              },
            },
            filters: [
              {
                $schema: 'http://powerbi.com/product/schema#advanced',
                target: {
                  table,
                  column,
                },
                operator: 'In',
                values: [data?.providerDetail?.providerId || null] as any,
              },
            ],
          } as any);
        } else {
          messageApi.warning('Something went wrong! Please try again.');
        }
      })
      .catch((err: Error) => console.error(err));
    dispatch(setDashboardFilter({}, dashboardType));
  }, []);

  useEffect((): any => {
    const { fromMonth, toMonth } = dashboardFilter || searchForm.getFieldsValue(['fromMonth', 'toMonth']);
    const filterToSet: any[] = [];
    if (fromMonth && toMonth) {
      const startDate: any = new Date(dashboardFilter?.fromMonth);
      const endDate: any = new Date(dashboardFilter?.toMonth);
      const updatedStartDate: any =
        new Date(`${startDate?.getMonth() + 1} ${startDate?.getDate()} ${startDate?.getFullYear()} 00:00:01 UTC`);
      const updatedEndDate: any = new Date(`${endDate?.getMonth() + 1} ${endDate?.getDate()} ${endDate?.getFullYear()} 23:59:59 UTC`);
      filterToSet.push(
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table: filterTableName ? filterTableName : table,
            column: filterColumnName,
          },
          logicalOperator: 'And',
          conditions: [
            {
              operator: 'GreaterThanOrEqual',
              value: new Date(updatedStartDate).toJSON().slice(0, -1),
            },
            {
              operator: 'LessThan',
              value: new Date(updatedEndDate).toJSON().slice(0, -1),
            },
          ]
        }
      );
      const updatedConfigData = {
        ...config,
        filters: filterToSet,
      };
      setConfig(updatedConfigData);
    } else if (reloadPbi) {
      const data = JSON.parse(localStorage.getItem('data') || '{}');
      filterToSet.pop();
      filterToSet.push(
        {
          $schema: 'http://powerbi.com/product/schema#advanced',
          target: {
            table,
            column,
          },
          operator: 'In',
          values: [data?.providerDetail?.providerId || null] as any,
        },
      );
      const resetedConfigData = {
        ...config,
        filters: filterToSet,
      };
      setConfig(resetedConfigData);
    }
  }, [reloadPbi]);

  const downloadDashboardPdf = (): any => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_URL}${DASHBOARD_PDF_DOWNLOAD}`;
    const filters: any = [];
    if (dashboardFilter?.fromMonth && dashboardFilter?.toMonth) {
      const startDate: any = new Date(dashboardFilter?.fromMonth);
      const endDate: any = new Date(dashboardFilter?.toMonth);
      const updatedStartDate: any =
        new Date(`${startDate?.getMonth() + 1} ${startDate?.getDate()} ${startDate?.getFullYear()} 00:00:01 UTC`);
      const updatedEndDate: any = new Date(`${endDate?.getMonth() + 1} ${endDate?.getDate()} ${endDate?.getFullYear()} 23:59:59 UTC`);

      filters.push({
        property: 'ClaimSubmittedDate',
        values: `\'${new Date(updatedStartDate).toJSON().slice(0, -1)}\',\'${new Date(updatedEndDate).toJSON().slice(0, -1)}\'`,
      });
    }
    const data = JSON.parse(localStorage.getItem('data') || '{}');
    const accessToken = cookieStore.get('accessToken') || '';
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', AccessToken: accessToken },
      body: JSON.stringify({
        filters,
        dashboardType,
        profileId: data?.userDetail?.profileId, providerName: data?.providerDetail?.providerName,
        providerId: data?.providerDetail.providerId, applicationId: 9233,
      }),
    };
    try {
      fetch(url, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data?.isSuccess) {
            const linkSource = 'data:' + 'application/pdf' + ';base64,' + data?.file;
            const downloadLink = document.createElement('a');
            downloadLink.href = linkSource;
            downloadLink.download = `metrics-dashboard.pdf`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            messageApi.info('Downloaded Successfully');
          } else {
            messageApi.warning('Something went wrong! Please try again.');
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error('Download failed:', error);
        });
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  };

  const resetFilter = (): any => {
    setReloadPbi(reloadPbi + 1);
    dispatch(setDashboardFilter({}, ''));
    searchForm.resetFields();
    setIsVisible(false); setTimeout(() => { setIsVisible(true); }, 500);
  };

  const onFormChange = (data: any): any => {
    setReloadPbi(reloadPbi + 1);
    const updatedFilterData = {
      ...dashboardFilter,
      ...data,
    };
    dispatch(setDashboardFilter(updatedFilterData, dashboardType));
  };

  const disabledDate = (current: any, dateType: string): any => {
    if (dateType === 'fromMonth') {
      const { toMonth } = searchForm.getFieldsValue(['toMonth']);
      return dashboardFilter?.fromMonth && dashboardFilter?.toMonth ? current &&
        current > toMonth?.endOf('day') : current && current.valueOf() > Date.now();
    } else {
      const { fromMonth } = searchForm.getFieldsValue(['fromMonth']);
      const dateCheck = fromMonth?.isSame(Date.now(), 'day');
      return searchForm.getFieldsValue(['fromMonth'])?.fromMonth ? dateCheck ? moment().add(-1, 'days') >= current ||
        moment().add(1, 'month') <= current || current && current.valueOf() > Date.now() : current &&
        current.valueOf() > Date.now() || current < fromMonth?.endOf('day') : current && current.valueOf() > Date.now();
    }
  }

  const logoutHandler = () => {
    cookieStore.remove('accessToken');
    localStorage?.setItem('data', '');
    dispatch(logout());
    history.replace('/');
  };

  return (
    <div>
      <button onClick={logoutHandler} className="logout-btn">
        <LeftArrow className="logout-arrow" />&nbsp;&nbsp; Logout
      </button>
      {process.env.REACT_APP_TIME_PERIOD_FILTER_REQUIRED === 'true' && timePeriodFilterRequired &&
        <Form
          form={searchForm}
          onValuesChange={onFormChange}
        >
          <Row>
            <Col span={2} className="fsize_sm gray-text custom-lebel" >Time Period:</Col>
            <Col span={3}>
              <Form.Item name="fromMonth">
                <DatePicker
                  placeholder="From"
                  allowClear={true}
                  disabledDate={(e: any): any => disabledDate(e, 'fromMonth')}
                />
              </Form.Item>
            </Col>

            <Col span={3}>
              <Form.Item name="toMonth">
                <DatePicker
                  placeholder="To"
                  allowClear={true}
                  disabledDate={(e: any): any => disabledDate(e, 'toMonth')}
                />
              </Form.Item>
            </Col>
            <Col span={11}>
              <Tooltip title="Reset filter" mouseEnterDelay={0.25}>
                <Button
                  onClick={resetFilter}
                  type={(isFilterApplied) ? 'primary' : 'default'}
                  icon={<FilterOutlined />}
                />
              </Tooltip>
            </Col>
            <Col span={1}>
              {contextHolder}
              <Button
                className="btn-download"
                onClick={downloadDashboardPdf}
                loading={loading}
              >
                <img
                  src={`${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/download-icon.svg`}
                  style={{ marginRight: '5px' }}
                  alt={'Download Icon'}
                />
                Download
              </Button></Col>
          </Row>
        </Form>
      }
      {
        config && isVisible ? <PowerBIEmbed
          embedConfig={config as any}
          cssClassName="power-bi-report"
        /> : null
      }
    </div>
  );
}

